import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { projects } from '../data/projects';

const ProjectsGrid: React.FC = () => {
  const featuredProjects = projects.filter(project => project.featured);

  return (
    <section id="projects" className="projects-section">
      <div className="projects-container">
        {/* Header */}
        <motion.div
          className="projects-header"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <p className="projects-eyebrow">Our Work</p>
          <h2 className="projects-title">
            Featured Projects
          </h2>
          <p className="projects-description">
            Explore our portfolio of successful digital transformations and innovative solutions
            delivered to clients across various industries.
          </p>
        </motion.div>

        {/* Alternating Showcase */}
        <div className="projects-showcase">
          {featuredProjects.map((project, index) => (
            <motion.div
              key={project.id}
              className={`showcase-row${index % 2 === 1 ? ' reverse' : ''}`}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-100px' }}
              transition={{ duration: 0.6 }}
            >
              <Link to={`/projects/${project.id}`} className="showcase-media">
                <img
                  src={project.imageUrl}
                  alt={project.title}
                  className="showcase-image"
                  onError={(e) => {
                    const target = e.target as HTMLImageElement;
                    target.style.display = 'none';
                    const placeholder = target.nextElementSibling as HTMLElement;
                    if (placeholder) placeholder.style.display = 'flex';
                  }}
                />
                <div className="project-image-placeholder-enhanced" style={{ display: 'none' }}>
                  {project.title.charAt(0)}
                </div>
                {project.featured && (
                  <span className="featured-badge-enhanced">Featured</span>
                )}
              </Link>

              <div className="showcase-content">
                <p className="project-category">{project.category}</p>
                <h3 className="showcase-title">{project.title}</h3>
                <p className="project-client">Client: {project.client}</p>
                <p className="showcase-description">{project.description}</p>

                <div className="project-tech-stack-enhanced">
                  {project.technologies.slice(0, 4).map((tech, techIndex) => (
                    <span key={techIndex} className="project-tech-badge">
                      {tech}
                    </span>
                  ))}
                  {project.technologies.length > 4 && (
                    <span className="project-tech-badge">+{project.technologies.length - 4}</span>
                  )}
                </div>

                <Link to={`/projects/${project.id}`} className="showcase-link">
                  View Project
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <line x1="5" y1="12" x2="19" y2="12" />
                    <polyline points="12 5 19 12 12 19" />
                  </svg>
                </Link>
              </div>
            </motion.div>
          ))}
        </div>

        {/* CTA Section */}
        <motion.div
          className="projects-cta-section"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.4 }}
        >
          <button
            className="projects-cta-btn"
            onClick={() => {
              const element = document.getElementById('contact');
              if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
              }
            }}
          >
            Start Your Project →
          </button>
        </motion.div>
      </div>
    </section>
  );
};

export default ProjectsGrid;
